import React from 'react'

export function Container({
  children,
  size = 'max-w-5xl',
  padding = 'px-4',
  className = '',
}) {
  return (
    <div className={padding}>
      <div className={`${size} mx-auto ${className}`}>{children}</div>
    </div>
  )
}
